import React, { useEffect, useState } from 'react'
import Content from 'blocks.app/content/content'
import CustomList from 'blocks.app/customList/customList'
import Link from 'blocks.simple/link/link'
import translate from 'core/translate'
import { Steps } from 'atoms/Steps/Steps-view'
import { useLocation } from 'react-router'
import { getURLSearchParamsByLocation, getURLSearchParamsString } from 'features/routes/utils'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import styles from './instancesCatalog_burgers.jcss'
import { BURGERS_CATALOG_TITLE_KEY, BurgersSelectedItems } from './InstancesCatalogBurgers-types'

const categories = ['chicken', 'premium', 'beef'] as const

const InstancesCatalogBurgersComponent = () => {
    const location = useLocation()
    const category = categories.find((item) => item === getURLSearchParamsByLocation(location).category) || 'chicken'
    const [selectedItems, setSelectedItems] = useState<BurgersSelectedItems>([])

    useEffect(() => {
        setSelectedItems([])
    }, [category])

    return (
        <Content title={BURGERS_CATALOG_TITLE_KEY}>
            <div className={styles.wrapper}>
                <Steps className={styles.tabs} active={category}>
                    {categories.map((item) => (
                        <Link
                            id={item}
                            key={item}
                            to={{
                                pathname: location.pathname,
                                search: getURLSearchParamsString({ category: item }),
                            }}
                        >
                            {translate(item)}
                        </Link>
                    ))}
                </Steps>
                <CustomList
                    key={category}
                    type={`burgers${category[0].toUpperCase()}${category.slice(1)}`}
                    onSelect={setSelectedItems}
                    selectedItems={selectedItems}
                    additionalData={{}}
                />
            </div>
        </Content>
    )
}

export const InstancesCatalogBurgers = checkAvailableModule('instancesCatalog/burgers')
    ? InstancesCatalogBurgersComponent
    : null
